'use client';

import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

type Context = {
  password: string;
  setPassword: Dispatch<SetStateAction<string>>;
};

const PasswordsContext = createContext<Context | null>(null);

interface Props {
  children: ReactNode;
}

const PasswordsProvider = ({ children }: Props) => {
  const [password, setPassword] = useState('');

  const value = { password, setPassword };

  return (
    <PasswordsContext.Provider value={value}>
      {children}
    </PasswordsContext.Provider>
  );
};

function usePasswords() {
  const context = useContext(PasswordsContext);
  if (!context) throw new Error('usePasswords requires a context!');

  return context;
}

export { PasswordsProvider, usePasswords };
